<template>
	<div class="tg-page-root le-page">
		<!-- Header Section -->
		<div class="header-section">
			<div class="header-visual">
				<img src="@/assets/img/le_logo.png" class="logo" mode="heightFix">
				<img src="@/assets/img/le_asset_01.jpg" class="globe-img" mode="widthFix">
			</div>
		</div>

		<!-- Intro Section -->
		<div class="intro-section">
			<div class="intro-text">
				
				<span class="h1">{{ $t('Leen_Intro_Title') }}</span>
				<span class="p">{{ $t('Leen_Intro_Desc') }}</span>
			</div>
			<div class="intro-img-box">
				<!-- Assumption: le_asset_02.jpg is the +852 phone img -->
				<img src="@/assets/img/le_asset_02.jpg" class="intro-img" mode="widthFix">
			</div>
		</div>

		<!-- Product & Service Section -->
		<div class="product-section">
			<div class="section-title-box">
				<span class="h2">{{ $t('Leen_Product_Title') }}</span>
			</div>

			<div class="product-card">
				<!-- Background img -->
				<img src="@/assets/img/le_asset_03.jpg" class="card-bg" mode="aspectFill">
				
				<div class="card-content">
					<div class="card-header">
						<div class="card-titles">
							<span class="card-title">{{ $t('Leen_Card_Title') }}</span>
							<span class="card-subtitle">{{ $t('Leen_Card_Subtitle') }}</span>
						</div>
						<!-- Corner Icon -->
						<img src="@/assets/img/le_asset_04.png" class="card-icon" mode="widthFix">
					</div>

					<div class="feature-list">
						<div class="feature-item" v-for="(item, index) in features" :key="index">
							<div class="check-circle">
								<img class="check-mark" src="@/assets/img/le_asset_05.png" mode="">
							</div>
							<span class="feature-text">{{ item }}</span>
						</div>
					</div>
				</div>
			</div>

			<span class="supported-label">{{ $t('Leen_Supported_Platforms') }}</span>
			<div class="social-icons">
				<!-- Assumption: 05-10 are social icons -->
				<img src="@/assets/img/le_asset_06.png" class="social-icon" mode="widthFix">
				<img src="@/assets/img/le_asset_07.png" class="social-icon" mode="widthFix">
				<img src="@/assets/img/le_asset_08.png" class="social-icon" mode="widthFix">
				<img src="@/assets/img/le_asset_09.png" class="social-icon" mode="widthFix">
				<img src="@/assets/img/le_asset_10.png" class="social-icon" mode="widthFix">
				<img src="@/assets/img/le_asset_11.png" class="social-icon" mode="widthFix">
			</div>
		</div>

		<!-- What We Offer Section -->
		<div class="offer-section">
			<span class="h2 align-left">{{ $t('Leen_Offer_Title') }}</span>
			
			<div class="offer-container-card">
				<div class="offer-grid">
					<!-- Assumption: 11-14 are grid icons -->
					<div class="offer-item">
						<div class="offer-icon-box">
							<img src="@/assets/img/le_asset_13.png" class="offer-icon" mode="widthFix">
						</div>
						<span class="offer-text">{{ $t('Leen_Offer_Item_1') }}</span>
					</div>
					<div class="offer-item">
						<div class="offer-icon-box">
							<img src="@/assets/img/le_asset_14.png" class="offer-icon" mode="widthFix">
						</div>
						<span class="offer-text">{{ $t('Leen_Offer_Item_2') }}</span>
					</div>
					<div class="offer-item">
						<div class="offer-icon-box">
							<img src="@/assets/img/le_asset_15.png" class="offer-icon" mode="widthFix">
						</div>
						<span class="offer-text">{{ $t('Leen_Offer_Item_3') }}</span>
					</div>
					<div class="offer-item">
						<div class="offer-icon-box">
							<img src="@/assets/img/le_asset_16.png" class="offer-icon" mode="widthFix">
						</div>
						<span class="offer-text">{{ $t('Leen_Offer_Item_4') }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="offer-footer">{{ $t('Leen_Offer_Footer') }}</div>

		<!-- Footer Section -->
		<div class="footer-section">
			<div class="footer-content">
				<div class="footer-header">
					<span class="footer-label">{{ $t('Global') }}</span>
					<span class="footer-label">{{ $t('Leen_Footer_Label_Service') }}</span>
				</div>
				
				<div class="footer-main-title">
					<span class="h1">{{ $t('Leen_Footer_Main_Title_1') }}</span>
					<span class="h1">{{ $t('Leen_Footer_Main_Title_2') }}</span>
				</div>

				<span class="footer-desc">
					{{ $t('Leen_Footer_Desc') }}
				</span>

				<div class="footer-cta-text">
					<template v-if="$i18n.locale === 'en'">
						<span class="h3">{{ $t('Leen_Footer_Cta_1') }}</span>
						<span class="h3">{{ $t('Leen_Footer_Cta_2') }}</span>
					</template>
					<template v-else>
						<span class="h3">{{ $t('Leen_Footer_Cta_1') }}{{ $t('Leen_Footer_Cta_2') }}</span>
					</template>
				</div>
				
			</div>
			
			
			
			<!-- Footer Decorative img -->
			<img src="@/assets/img/le_asset_17.png" class="footer-deco-img" mode="widthFix">

			
			<img src="@/assets/img/le_asset_18.png" class="floating-sim" mode="widthFix">
		</div>
		
		<div class="signup-btn">
			<div class="btn" @click="goRegister">
				{{ $t('Leen_Signup_Btn') }}
			</div>
		</div>
	</div>
</template>

<script>
	import { setStorage } from '@/utils/storage'
	import { STORAGE_KEYS } from '@/constants/storageKeys'
	import { pickReferrerQuery } from '@/utils/referrerFromQuery'

	export default {
		data() {
			return {
				
			};
		},
		created() {
			// 设置 App Source 为 lesim-le (使用 created 确保在 API 请求前生效)
			setStorage(STORAGE_KEYS.APP_SOURCE, 'lesim-le')
		},
		methods: {
			goRegister() {
				const q = pickReferrerQuery(this.$route.query)
				if (Object.keys(q).length) {
					this.$router.push({ path: '/register', query: q })
				} else {
					this.$router.push('/register')
				}
			}
		},
		computed: {
			features() {
				return [
					this.$t('Leen_Feature_1'),
					this.$t('Leen_Feature_2'),
					this.$t('Leen_Feature_3'),
					this.$t('Leen_Feature_4'),
					this.$t('Leen_Feature_5')
				];
			}
		}
	}
</script>

<style lang="scss">
	$primary-color: #00C874; // Vibrant green
	$text-dark: #111111;
	$text-gray: #666666;
	$bg-light: #F8F9FB;

	.le-page {
		width: 100%;
		min-height: 100vh;
		background-color: #FFFFFF;
		padding-bottom: 60rpx;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
		@media (min-width: 768px) {
			width: 375px;
			max-width: 375px;
			margin: 0 auto;
		}
		
		
		.highlight {
			color: $primary-color;
		}
		
		/* Header */
		.header-section {
			position: relative;
			overflow: visible; // Allow SIMs to float out if needed
			margin-bottom: 20rpx;
		
			.header-visual {
				position: relative;
				display: flex;
				justify-content: flex-end;
				position: relative;
				.logo {
					width: 175rpx;
					height: 61rpx;
					position: absolute;
					top: 84rpx;
					left: 78rpx;
					z-index: 1;
				}
				.globe-img {
					width: 100%;
					height: 528rpx;
				}
		
			}
		}
		
		/* Intro */
		.intro-section {
			padding: 40rpx 50rpx 40rpx 50rpx;
			margin-top: -20rpx; // Pull up slightly
		
			.h1 {
				font-size: 56rpx; // Increased size
				font-weight: 800;
				color: $text-dark;
				line-height: 1.15;
				display: block;
				margin-bottom: 30rpx;
				background: linear-gradient(160deg, #1F1F1F 30%, #00D06D 65%, #00D06D 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}
		
			.p {
				font-family: Inter;
				font-weight: 500;
				font-size: 26rpx;
				color: #000000;
				line-height: 39rpx;
			}
		
			.intro-img-box {
				display: flex;
				justify-content: center;
				margin-top: 74rpx;
				.intro-img {
					width: 496rpx;
					height: 425rpx;
				}
			}
		}
		
		/* Product */
		.product-section {
			padding: 70rpx 0 40rpx ;
			width: 670rpx;
			margin: 0 auto;
			.section-title-box {
				margin-bottom: 40rpx;
				.h2 {
					font-weight: 800;
					font-size: 50rpx;
					color: #000000;
					line-height: 61rpx;
					background: linear-gradient(160deg, #1F1F1F 30%, #00D06D 81%, #00D06D 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}
		
			.product-card {
				position: relative;
				border-radius: 40rpx;
				padding: 45rpx 34rpx 0rpx 34rpx;
				margin-bottom: 50rpx;
				width: 670rpx;
				height: 478rpx;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				.card-bg {
					position: absolute;
					top: 0;
					right: 0;
					width: 100%;
					height: 100%;
				}
		
				.card-content {
					position: relative;
					z-index: 1;
					background-color: rgba(255, 255, 255, 0.8);
					border-radius: 20rpx 20rpx 0 0;
					padding: 0 38rpx;
					flex: 1;
					.card-header {
						position: relative;
						margin-bottom: 20rpx;
						border-bottom: 1px solid #B3B3B3;
						height: 140rpx;
						display: flex;
						flex-direction: column;
						justify-content: center;
						.card-title {
							display: block;
							font-size: 32rpx;
							font-weight: 700;
							color: #000000;
							margin-bottom: 4rpx;
						}
						.card-subtitle {
							display: block;
							font-size: 26rpx;
							color: #000000;
						}
						
						.card-icon {
							position: absolute;
							top: -40rpx;
							right: -90rpx;
							width: 157rpx;
							height: 142rpx;
						}
					}
		
					.feature-list {
						.feature-item {
							display: flex;
							align-items: center;
							line-height: 45rpx;
							.check-circle {
								display: flex;
								align-items: center;
								justify-content: center;
								margin-right: 14rpx;
								margin-top: 4rpx;
								.check-mark {
									color: white;
									font-size: 22rpx;
									font-weight: bold;
									width: 26rpx;
									height: 26rpx;
									border-radius: 50%;
								}
							}
		
							.feature-text {
								font-size: 22rpx;
								color: #000000;
								font-weight: 500;
							}
						}
					}
				}
			}
		
			.supported-label {
				display: block;
				text-align: center;
				font-size: 24rpx;
				color: #000000;
				font-weight: 500;
				margin-bottom: 34rpx;
			}
		
			.social-icons {
				display: flex;
				justify-content: center;
				gap: 40rpx;
				padding-right: 40rpx;
				.social-icon {
					width: 42rpx;
					height: 42rpx;
				}
			}
		}
		
		/* Offer - REDESIGNED */
		.offer-section {
			margin: 40rpx 0 0 40rpx;
			background-image: url('@/assets/img/le_asset_12.png');
			background-size: 100% 100%;
			height: 572rpx;
			.h2 {
				font-weight: bold;
				font-size: 38rpx;
				color: #000000;
				margin-bottom: 40rpx;
				display: block;
			}
		
			.offer-container-card {
				border-radius: 40rpx;
				padding: 24rpx;
			}
		
			.offer-grid {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 20rpx;
			}
		
			.offer-item {
				background: linear-gradient(24deg, #FFFFFF, #E1FDF0);
				border-radius: 30rpx;
				display: flex;
				flex-direction: column;
				align-items: center;
				text-align: center;
				justify-content: center;
				width: 300rpx;
				height: 186rpx;
				.offer-icon-box {
					width: 58rpx;
					height: 58rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-bottom: 18rpx;
					.offer-icon {
						width: 100%;
						height: 100%;
					}
				}
		
				.offer-text {
					font-weight: 500;
					font-size: 22rpx;
					color: #000000;
					line-height: 26rpx;
				}
			}
			
		}
		.offer-footer {
			display: block;
			text-align: center;
			font-weight: 500;
			font-size: 28rpx;
			color: #000000;
			line-height: 39rpx;
			background: linear-gradient(160deg, #18B86F 0%, #04CF73 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			margin-top: 0rpx;
		}
		
		/* Footer */
		.footer-section {
			position: relative;
			padding: 80rpx 60rpx 0 80rpx;
			overflow: hidden;
		
			
			.floating-sim {
				position: absolute;
				width: 70rpx;
				height: 70rpx;
				bottom: 335rpx;
				left: 0;
			}
		
			.footer-content {
				position: relative;
				z-index: 2;
			}
		
			.footer-header {
				margin-bottom: 10rpx;
				.footer-label {
					display: block;
					font-size: 31rpx;
					color: #000000;
					line-height: 39rpx;
				}
			}
		
			.footer-main-title {
				margin-bottom: 40rpx;
				color: #000000;
				background: linear-gradient(160deg, #1F1F1F 20%, #00D06D 70%, #00D06D 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				line-height: 74rpx;
				.h1 {
					display: block;
					font-size: 61rpx;
					font-weight: 800;
				}
			}
		
			.footer-desc {
				display: block;
				font-size: 22rpx;
				color: #000000;
				line-height: 34rpx;
				margin-bottom: 60rpx;
				max-width: 95%;
			}
		
			.footer-cta-text {
				margin-bottom: 80rpx;
				color: #000000;
				background: linear-gradient(160deg, #1F1F1F 20%, #00D06D 70%, #00D06D 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				font-size: 36rpx;
				font-weight: 800;
				.h3 {
					display: block;
					line-height: 50rpx;
				}
			}
		
		
			.footer-deco-img {
				position: absolute;
				right: 16rpx;
				top: 20rpx;
				width: 150rpx;
				height: 130rpx;
				z-index: 1;
				transform: rotate(15deg);
			}
		}
		.signup-btn {
			background-image: url('@/assets/img/le_asset_20.png');
			background-size: 100% 100%;
			width: 708rpx;
			height: 133rpx;
			margin: 0 auto 0 auto;
			display: flex;
			justify-content: center;
			.btn {
				width: 668rpx;
				height: 93rpx;
				background: linear-gradient(90deg, #00B060, #01D273);
				border-radius: 47rpx;
				font-size: 30rpx;
				color: #FFFFFF;
				font-weight: bold;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
			}
		}
	}
</style>